export default __webpack_public_path__ + "static/media/Ellipse 40.e82bdeb2.png";